import Layout from '@/layout';

export default [
    // 管理端首页（需要登录）
    {
        path: '/dashboard',
        component: Layout,
        redirect: '/dashboard/home',
        name: 'app-dashboard',
        children: [
            {
                path: 'home',
                component: () => import('@/views/home/home.vue'),
                name: 'dashboard',
                meta: {
                    allowShow: true,
                    icon: 'HomeFilled',
                    title: '首页',
                },
            },
        ],
    },
];